import React from 'react';

import { Page } from 'src/components';

const Legals = () => (
  <Page>
    <Page.Main className="pt-16 mx-auto max-w-screen-2xl">
      <iframe
        title="Mentions légales"
        src="./equilibre-legals.pdf"
        className="w-full"
        style={{ minHeight: 'calc(100vh - 4rem)' }}
      />
    </Page.Main>
  </Page>
);

export default Legals;
